import React, { useEffect } from "react";
import { Button, Grid, Paper, Stack, Typography } from "@mui/material";
import GotraTableComponent from "../../../components/admin/gotra-manager/GotraTable";
import { GotraAddDrawer } from "../../../components/admin/gotra-manager/GotraAddDrawer";
import { useGetGotraListQuery } from "../../../store/masters/mastersApis";
import { SearchRecords } from "../../../components/Common/SearchRecords";
import { Add } from "@mui/icons-material";
import { GotraInitialForm } from "../../../store/masters/mastersSlice";

const GotraManagerContainer = (props) => {
    const { showDrawer, formType, initialValues, pagination } = props;
    const { isLoading, data: gotra, isFetching } = useGetGotraListQuery(pagination);

    const handleAddGotra = () => {
        props.changeMastersInitialState({
            showDrawer: true,
            formType: "Add",
            initialValues: GotraInitialForm
        })
    }

    useEffect(() => {
        props.handlePaginationState({
            pageNo: 0,
            limit: 10,
            sortBy: -1,
            sortField: "createdAt",
            keywords: ""
        })
    }, []);

    const handlePagination = (setting) => {
        props.handlePaginationState(setting);
    }

    const handleDrawerClose = () => {
        props.changeMastersInitialState({ showDrawer: false, formType: "", initialValues: GotraInitialForm })
    }

    const handleGotraEdit = (data, type) => {
        let payload = { ...data };
        delete payload.createdAt;
        props.changeMastersInitialState({ showDrawer: true, formType: type, initialValues: payload })
    }

    return (
        <Stack spacing={1}>
            <Paper sx={{ marginBottom: "24px", padding: 1.5 }}>
                <Grid container justifyContent="space-between">
                    <Grid item sx={{ alignSelf: "center" }}>
                        <Typography variant="h6">List of Gotra</Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            disableElevation
                            variant="contained"
                            sx={{ borderRadius: "50px" }}
                            onClick={() => handleAddGotra()}
                            startIcon={<Add />}
                        >
                            Add
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            <Grid container>
                <SearchRecords handlePagination={handlePagination} pagination={pagination} />
                <Grid item xs={12}>
                    <Paper
                        sx={{ p: 2, color: "#071B2A", fontWeight: "400" }}
                        elevation={0}
                    >
                        <GotraTableComponent fetching={isFetching} edit={(val, type) => handleGotraEdit(val, type)} loading={isLoading} count={gotra?.count || 0} data={gotra?.result || []} pagination={pagination} handlePagination={(val) => handlePagination(val)} />
                    </Paper>
                </Grid>
            </Grid>

            {/* add taf drawer */}
            <GotraAddDrawer show={showDrawer} close={handleDrawerClose} formType={formType} initialValues={initialValues} />

        </Stack >
    );
}

export default GotraManagerContainer;